import {combineEpics} from 'web-app/util/redux-observable';

import balanceReportEpics from './balance-report/epics';
import asyncReportEpics from './async-report/epics';
import organizationOverviewEpics from './organization-overview/epics';
import manageOrganizationEmployees from './manage-employees/epics';

export default combineEpics(
    asyncReportEpics,
    balanceReportEpics,
    organizationOverviewEpics,
    manageOrganizationEmployees,
);
